import { ExpandedFlightCardProps } from "./types";

import { ExpandedCardContainer, ExpandedCardScrollable } from "./styles";
import { SellersList } from "Components/molecules/SellersList";
import { FlightDetails } from "Components/molecules/FlightDetails";
import { FlightDetailsFooter } from "Components/molecules/FlightDetailsFooter";

/**
 * Componente ExpandedFlightCard
 *
 * Exibe informações detalhadas sobre o voo, incluindo lista de preços e detalhes dos segmentos de ida e volta.
 *
 * @param {SERPCardResult} cardResult - Resultados de um Card
 * @param {Function} onClose - Callback para fechar o card expandido.
 */
export const ExpandedFlightCard: React.FC<ExpandedFlightCardProps> = ({
  cardResult,
  mode,
  onClose,
  onWhereToBuy,
}) => {
  return (
    <ExpandedCardContainer id={"expanded-card-container"}>
      <ExpandedCardScrollable>
        {mode === "sellers" ? (
          <>
            <SellersList
              sellers={cardResult?.sellers}
              cardResult={cardResult}
            />
            <FlightDetails sectors={cardResult?.sectors} onClose={onClose} />
          </>
        ) : (
          <>
            <SellersList
              sellers={cardResult?.sellers}
              cardResult={cardResult}
            />
            <FlightDetails sectors={cardResult?.sectors} onClose={onClose} />
          </>
        )}
      </ExpandedCardScrollable>

      <FlightDetailsFooter onClose={onClose} onNavigate={onWhereToBuy} />
    </ExpandedCardContainer>
  );
};
